import React from 'react';
import { GridCol } from '@naf/grid';
import { CenterProducts, DisplayStyle } from '../../../../../types/centerArticleType';
import { ProductPairBlock } from './components/ProductPair';
import { StandardProductBlock } from './components/StandardProduct';

interface Props {
  products: CenterProducts[];
}

const Product = ({ products }: { products: CenterProducts[] }) => {
  if (products.length > 1) {
    /* EU kontroll og NAF test */
    return <ProductPairBlock products={products} />;
  }
  if (
    products[0].displayStyle === DisplayStyle.WithPricePrimaryButton ||
    products[0].displayStyle === DisplayStyle.WithPriceSecondaryButton
  ) {
    /* NAF senter product */
    return <StandardProductBlock product={products[0]} />;
  }
  if (products[0].displayStyle === DisplayStyle.WithoutPrice) {
    /* Oljeskift / Reparasjon og service */
    return null;
  }
  if (products.length === 1 && !products[0].displayStyle) {
    return null;
  }
  return null;
};

export const ProductPrice = ({ products }: Props) => {
  if (
    products[0].displayStyle === DisplayStyle.WithPricePrimaryButton ||
    products[0].displayStyle === DisplayStyle.WithPriceSecondaryButton
  ) {
    return (
      <GridCol s="12" m="12" l="12" xl="12">
        <Product products={products} />
      </GridCol>
    );
  }
  return null;
};
